<app-admin-dashboard>
  <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb>
  <p-card *ngIf="detail">
    <div class="grid" style="padding: 15px;">
      <div class="col-12">
        <div class="flex justify-content-between align-items-center">
          <h2>Editar pallets</h2>
          <h3>Código detalle de orden : {{detail.sequence}}</h3>
          <h3>Código de orden : {{detail.importOrderSequence}}</h3>
          <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelButton' | translate }}" icon="pi pi-upload" (click)="showDialog()"/>
        </div>
      </div>
      <div class="col-12">
        <div class="grid">
          <div class="col-3"><span style="font-weight: bolder;">Especie/Variedad:</span></div>
          <div class="col-3 flex align-items-center">
            <img [src]="detail.varietyUrlIcon | speciesImageUrl" style="border-radius: 7px; width: 18px; height: auto;" alt=""/> &nbsp;{{ detail.speciesNameEn }} / {{ detail.varietyName }}
          </div>
          <div class="col-3"><span style="font-weight: bolder;">Cantidad de pallets:</span></div>
          <div class="col-3">{{pallets.length}}</div>
          <div class="col-3"><span style="font-weight: bolder;">Frigorífico:</span></div>
          <div class="col-9">{{ detail.fridgeStorageName }}, {{ detail.fridgeStorageCity }} - {{ detail.fridgeStorageCountry }}</div>
        </div>
      </div>
    </div>

    <div class="m-4 container-width">
      <p-table
        [value]="pallets"
        dataKey="id"

        [tableStyle]="{ 'min-width': '50rem' }"
        responsiveLayout="stack"
        [breakpoint]="'600px'"
        styleClass="p-datatable-gridlines"
        [scrollable]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        scrollHeight="600px">
        <ng-template pTemplate="header">
          <tr>
            <th>Estado aprobación</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.FolioHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.VarietyHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ProducerHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesSizeHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.HarvestDateHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.QualityControlDateHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackagingHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletTypeHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TagHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BagTypeHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxTypeHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.NetWeightHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ColdStorageHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxePerPalletHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.MarksHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ContainerNumberHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.GradeHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TemptaleHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginCountryHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.Cert1Header' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.Cert2Header' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.Cert3Header' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadWeekHeader' | translate}}</th>
            <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.CategoryHeader' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pallet let-editing="editing" let-ri="rowIndex">
          <tr>
            <td>
              <i class="pi pi-hourglass" *ngIf="pallet.status == 1" pTooltip="Pendiente"></i>
              <i class="pi pi-check" style="color: slateblue" *ngIf="pallet.status == 2" pTooltip="Aprobado"></i>
              <i class="pi pi-times" style="color: darkred" *ngIf="pallet.status == 3" pTooltip="Rechazado"></i>
            </td>
            <td [pEditableColumn]="pallet.palletNumber" pEditableColumnField="palletNumber">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.palletNumber" maxlength="20" required/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.palletNumber}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportSpecies" pEditableColumnField="excelImportSpecies">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportSpecies" maxlength="100" required/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportSpecies}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportVariety" pEditableColumnField="excelImportVariety">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportVariety" maxlength="100" required/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportVariety}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.producer" pEditableColumnField="producer">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.producer" maxlength="200" required/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.producer}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.speciesSize" pEditableColumnField="speciesSize">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.speciesSize" maxlength="30"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.speciesSize}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportHarvestDate" pEditableColumnField="excelImportHarvestDate">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportHarvestDate" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportHarvestDate}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportQualityControlDate" pEditableColumnField="excelImportQualityControlDate">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportQualityControlDate" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportQualityControlDate}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportPackaging" pEditableColumnField="excelImportPackaging">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportPackaging" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportPackaging}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportPalletType" pEditableColumnField="excelImportPalletType">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportPalletType" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportPalletType}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportTag" pEditableColumnField="excelImportTag">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportTag" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportTag}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportBagType" pEditableColumnField="excelImportBagType">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportBagType" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportBagType}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportBoxSize" pEditableColumnField="excelImportBoxSize">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportBoxSize" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportBoxSize}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportNetWeight" pEditableColumnField="excelImportNetWeight">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportNetWeight" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportNetWeight}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportFridgeStorage" pEditableColumnField="excelImportFridgeStorage">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportFridgeStorage" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportFridgeStorage}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportBoxesPerPallet" pEditableColumnField="excelImportBoxesPerPallet">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportBoxesPerPallet" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportBoxesPerPallet}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportMark" pEditableColumnField="excelImportMark">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportMark" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportMark}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportContainerNumber" pEditableColumnField="excelImportContainerNumber">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportContainerNumber" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportContainerNumber}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportGrade" pEditableColumnField="excelImportGrade">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportGrade" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportGrade}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportTemptale" pEditableColumnField="excelImportTemptale">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportTemptale" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportTemptale}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportOriginCountry" pEditableColumnField="excelImportOriginCountry">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportOriginCountry" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportOriginCountry}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportCertificate1" pEditableColumnField="excelImportCertificate1">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportCertificate1" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportCertificate1}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportCertificate2" pEditableColumnField="excelImportCertificate1">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportCertificate2" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportCertificate2}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportCertificate3" pEditableColumnField="excelImportCertificate3">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportCertificate3" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportCertificate3}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportLoadWeek" pEditableColumnField="excelImportLoadWeek">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportLoadWeek" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.excelImportLoadWeek}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td [pEditableColumn]="pallet.excelImportLoadWeek" pEditableColumnField="category">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="pallet.excelImportLoadWeek" maxlength="50"/>
                </ng-template>
                <ng-template pTemplate="output">
                  {{pallet.category}}
                </ng-template>
              </p-cellEditor>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <form [formGroup]="formGroup">
        <div class="p-fluid formgrid grid" style="margin-top: 30px;">
          <div class="field col-12 md:col-6 lg:col-3" style="margin-bottom: 40px;">
            <label for="qualityControlDate">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.QualityControlDateLabel' | translate}} *</label>
            <p-calendar
              inputId="qualityControlDate"
              formControlName="qualityControlDate"
              appendTo="body"
              [showButtonBar]="true"
              [showIcon]="true"
              placeholder="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.QualityControlDateLabel' | translate}}"
              [showWeek]="true"
              [firstDayOfWeek]="1"></p-calendar>
            <small *ngIf="submit && formGroup.controls['qualityControlDate'].invalid" class="p-error">{{getErrorMessage(formGroup, 'qualityControlDate')}}</small>
          </div>
          <div class="field col-12" style="margin-bottom: 40px;">
            <label>Pdf Inspección de control de calidad</label>
            <p-fileUpload
              #QCReviewPdfUploader
              (onSelect)="onSelectQCReviewPdf($event)"
              [showUploadButton]="false"
              [multiple]="false"
              accept=".pdf"
              [maxFileSize]="5000000"
              chooseLabel="{{'UserPages.UserProductCertificates.Form.SelectFile' | translate}}"
              cancelLabel="{{'UserPages.UserProductCertificates.Form.CancelSelectFile' | translate}}"/>
          </div>
          <div class="field col-12" style="margin-bottom: 40px;">
            <label>Pdf Consolidación de control de calidad</label>
            <p-fileUpload
              #QCConsolidationPdfUploader
              (onSelect)="onSelectQCConsolidationPdf($event)"
              [showUploadButton]="false"
              [multiple]="false"
              accept=".pdf"
              [maxFileSize]="5000000"
              chooseLabel="{{'UserPages.UserProductCertificates.Form.SelectFile' | translate}}"
              cancelLabel="{{'UserPages.UserProductCertificates.Form.CancelSelectFile' | translate}}"/>
          </div>
        </div>
      </form>

      <div class="p-fluid formgrid grid" style="padding: 20px; margin-top: 40px;">
        <div class="field col-12 md:col-6 lg:col-6" style="margin-bottom: 40px;"></div>
        <div class="field col-12 md:col-3 lg:col-3" style="margin-bottom: 40px;">
          <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BackButton' | translate}}" (onClick)="onCancel()" styleClass="p-button-outlined" [loading]="loading"></p-button>
        </div>
        <div class="field col-12 md:col-3 lg:col-3" style="margin-bottom: 40px;">
          <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SaveButton' | translate}}" (onClick)="save()" [loading]="loading"></p-button>
        </div>
      </div>
    </div>
  </p-card>

  <p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.DialogTitle' | translate}}" [(visible)]="visible" [modal]="true" [style]="{width: '50vw'}">
    <form [formGroup]="palletFormGroup">
      <div class="p-fluid formgrid grid">
        <div class="field col-12" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadFileFieldLabel' | translate}}</label>
          <p-fileUpload
            #excelUploader
            mode="basic"
            [multiple]="false"
            [auto]="true"
            chooseLabel="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadFileFieldPlaceholder' | translate}}"
            name="demo[]"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            [maxFileSize]="1000000"
            (onSelect)="onSelectExcelFile(excelUploader)">
          </p-fileUpload>
          <p *ngIf="excelFile">{{excelFile.name}}</p>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SheetFiedlLabel' | translate}}</label>
          <p-dropdown [options]="excelSheets" [(ngModel)]="selectedSheet" [ngModelOptions]="{standalone: true}" [disabled]="!excelFile"></p-dropdown>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.StartRowFieldLabel' | translate}} *</label>
          <p-inputNumber formControlName="startRow" [min]="1" [maxlength]="10" [disabled]="!excelFile" placeholder=""/>
          <small *ngIf="palletFormGroup.controls['startRow'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'startRow')}}</small>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;"></div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FolioColumnFieldLabel' | translate}} *</label>
          <input type="text" formControlName="folioColumn" pInputText maxlength="1" placeholder=""/>
          <small *ngIf="palletFormGroup.controls['folioColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'folioColumn')}}</small>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SpeciesColumnFieldLabel' | translate}} *</label>
          <input type="text" formControlName="speciesColumn" pInputText maxlength="1" placeholder=""/>
          <small *ngIf="palletFormGroup.controls['speciesColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'speciesColumn')}}</small>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.VarietyColumnFieldLabel' | translate}} *</label>
          <input type="text" formControlName="varietyColumn" pInputText maxlength="1" placeholder=""/>
          <small *ngIf="palletFormGroup.controls['varietyColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'varietyColumn')}}</small>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.ProducerColumnFieldLabel' | translate}} *</label>
          <input type="text" formControlName="producerColumn" pInputText maxlength="1" placeholder=""/>
          <small *ngIf="palletFormGroup.controls['producerColumn'].invalid" class="p-error">{{getErrorMessage(palletFormGroup, 'producerColumn')}}</small>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.SpeciesSizeColumnFieldLabel' | translate}}</label>
          <input type="text" formControlName="speciesSizeColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.HarvestDateColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="harvestDateColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.QualityControlDateColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="qualityControlDateColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.PackagingColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="packagingColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.PalletTypeColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="palletTypeColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.TagColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="tagColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.BagTypeColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="bagTypeColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.BoxSizeColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="boxSizeColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.NetWeightColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="netWeightColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.FridgeStorageColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="fridgeStorageColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.BoxesPerPalletColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="boxesPerPalletColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.MarkColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="markColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.ContainerNumberColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="containerNumberColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.GradeColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="gradeColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.TemptaleColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="temptaleColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.OriginCountryColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="originCountryColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.Certificate1ColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="certificate1Column" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.Certificate2ColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="certificate2Column" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.Certificate3ColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="certificate3Column" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadWeekColumnFielLabel' | translate}}</label>
          <input type="text" formControlName="loadWeekColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;">
          <label>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.Category' | translate}}</label>
          <input type="text" formControlName="loadWeekColumn" pInputText maxlength="1" placeholder=""/>
        </div>
        <div class="field col-12 xl:col-4 lg:col-4" style="margin-bottom: 40px;"></div>
        <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;"></div>
        <div class="field col-12 xl:col-6 lg:col-6" style="margin-bottom: 40px;">
          <p-button label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadExcelModal.LoadButton' | translate}}" (click)="onLoadExcel()" [disabled]="!excelFile"></p-button>
        </div>
      </div>
    </form>
  </p-dialog>
</app-admin-dashboard>


